import React from "react";
import OFRBuilderContent from "../components/trips/financials/ofr-builder";

const OFRBuilder = () => {
  return <OFRBuilderContent />;
};

export default OFRBuilder;
